import React, { useEffect, useState } from "react";
import heic2any from "heic2any";
import axiosInstance from "../../apis";
import { getPublicLinkForImage } from "../../services/auth.service";

const ImageWithConvert = (props: any) => {
  const [convertedImageUrl, setConvertedImageUrl] = useState<string | null>(
    null
  );
  const [privateUrl] = useState<string | undefined>(props.src);
  const [publicUrl, setPublicUrl] = useState<string | undefined>(undefined);

  const downloadImage = async () => {
    try {
      if (!privateUrl) return;
      const resLinkImg = await getPublicLinkForImage([privateUrl]);
      const imageLink = resLinkImg?.data?.links[0].downloadLink;
      // console.log({ resLinkImg, imageLink });
      const isHeic = isHeicImage(imageLink);
      if (isHeic) {
        const res = await convertImage(imageLink);
        setPublicUrl(res);
      } else {
        setPublicUrl(imageLink);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  function isHeicImage(url: string) {
    var pattern = /\.(heic)$/i;
    return pattern.test(url);
  }

  const convertImage = async (link: string) => {
    try {
      const response = await axiosInstance.get(link, {
        responseType: "blob",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const convertedBlob = await heic2any({
        blob: response.data,
        toType: "image/png",
      });
      const convertedUrl = URL.createObjectURL(
        Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob
      );
      console.log({ convertedUrl });
      return convertedUrl;
      // setConvertedImageUrl(convertedUrl);
    } catch (error) {
      console.error("Error converting image:", error);
      return undefined;
    }
  };
  function replaceHeicFormat(url: string) {
    var pattern = /\.HEIC$/i;
    if (pattern.test(url)) {
      return url.replace(pattern, ".heic");
    }
    return url;
  }

  //   useEffect(() => {
  //     if (isHeicImage(props?.src)) {
  //       convertImage();
  //     }

  //     // Clean up the URL object when the component is unmounted
  //     return () => {
  //       if (convertedImageUrl) {
  //         URL.revokeObjectURL(convertedImageUrl);
  //       }
  //     };
  //   }, [props?.src]);

  return (
    <img
      {...props}
      alt={props.alt ?? ""}
      // src={convertedImageUrl ?? props?.src}
      src={publicUrl ?? privateUrl ?? props.defaultsrc}
      onError={(e) => {
        downloadImage();
        console.log(e);
      }}
      // onError={(e) => {
      //   const isHeic = isHeicImage(props?.src);
      //   console.log({ isHeic });
      //   if (isHeic) convertImage();
      // }}
    />
  );
};

export default ImageWithConvert;
